import { Navigate } from "react-router-dom";

import OnboardingNotCompletedRequired from "@/layouts/auth/components/OnboardingNotCompletedRequired";
import TypeOfAccountRequired from "@/layouts/auth/components/TypeOfAccountRequired";
import VerifyGallery from "@/layouts/navigation/verify-gallery";
import AddArtwork from "@/pages/onboarding/add-artwork";
import AllArtworks from "@/pages/onboarding/all-artworks";            // 👈 nuevo
import ArtworkPreview from "@/pages/onboarding/artwork-preview";
import Drafts from "@/pages/onboarding/drafts";
import OnBoarding from "@/pages/onboarding/onboarding";
import UploadedArtworks from "@/pages/onboarding/uploaded-artworks";
import VerifiedArtworks from "@/pages/onboarding/verified-artworks";

/**
 * Routes for accounts not completed.
 */
const OnboardingRoutes = [
  {
    element: <OnboardingNotCompletedRequired />,
    children: [
      { path: "/onboarding/collector", element: <OnBoarding user_type="collector" /> },
      { path: "/onboarding/artist",    element: <OnBoarding user_type="artist" /> },
      { path: "/onboarding/gallery",   element: <OnBoarding user_type="gallery" /> },

      {
        element: <TypeOfAccountRequired allowedTypes={["gallery"]} />,
        children: [
          // ✅ Rutas oficiales (bonitas) bajo /gallery-onboarding
          { path: "/gallery-onboarding/add-artwork", element: <AddArtwork /> },
          { path: "/gallery-onboarding/preview",     element: <ArtworkPreview /> },

          {
            path: "/gallery-onboarding",
            element: <VerifyGallery />,
            children: [
              // 👉 Index: muestra ambas listas (Uploaded + Verified) en la misma página
              { index: true, element: <AllArtworks /> },

              // (opcional) mantén estas rutas internas si alguna parte de la app las usa
              { path: "uploaded-artworks",  element: <UploadedArtworks /> },
              { path: "verified-artworks",  element: <VerifiedArtworks /> },
              { path: "drafts",             element: <Drafts /> },
            ],
          },

          // 🔁 Redirecciones desde rutas viejas → a la nueva única
          { path: "/verify-gallery/add-artwork",              element: <AddArtwork replace/> },
          { path: "/verify-gallery/preview",                  element: <ArtworkPreview replace /> },
          { path: "/verify-gallery/uploaded-artworks",        element: <UploadedArtworks replace /> },
          { path: "/verify-gallery/verified-artworks",        element: <VerifiedArtworks replace /> },
          { path: "/verify-gallery/uploaded-artworks/drafts", element: <Drafts replace /> },
          { path: "/verify-gallery/*",                        element: <Navigate to="/gallery-onboarding" replace /> },
        ],
      },
    ],
  },
];

export default OnboardingRoutes;
